import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecurityServerService } from './SecurityServerService';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { RootNavigationManager } from '../../core/services/RootNavigationManager';

@Injectable()
export class AuthenticationRedirectGuard implements CanActivate {

  constructor(private securityServerService: SecurityServerService, private rootNavigationManager: RootNavigationManager) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> | Observable<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.securityServerService.checkAuthentication(false)
        .then(() => {
          if (this.securityServerService.userContext.isAuthenticated) {
            var path = sessionStorage.getItem(this.securityServerService.loginRedirectUrlKey);
            if (this.rootNavigationManager.isLandingPage(path)) {
              path = undefined;
            }
            if (this.securityServerService.userContext.permissionsLoaded) {
              setTimeout(() => sessionStorage.removeItem(this.securityServerService.loginRedirectUrlKey), 2000);
            }
            this.rootNavigationManager.goToPath(path);
          } else {
            sessionStorage.removeItem(this.securityServerService.loginRedirectUrlKey);
            this.rootNavigationManager.goToLanding();
          }
          resolve(true);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/security/services/AuthenticationRedirectGuard.ts